import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockOutDispatchModel } from "../stockOutDispatchModel";
import { IStockDeliveryDetail } from "../stockOutDispatchType"
import { momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "maintenance.return-visit": string, //已回访
    "maintenance.write-off": string, //已结款
    "maintenance.underway": string,//在修
    "maintenance.await": string,//待修
    "maintenance.trans": string,//已转接
    "maintenance.stock-io": string,//已出库
    "maintenance.settle": string,//已结算
    "maintenance.create": string,//已开单
    "maintenance.change": string,//已作废
    // "maintenance.create": string,    
    "maintenance.completed": string,
    "maintenance-status.final": string,
    [key: string]: any
}
const statusColor: statusType = {
    "maintenance.return-visit": 'lime', //已回访
    "maintenance.write-off": "green", //已结款
    "maintenance.underway": "geekblue",//在修
    "maintenance.await": "purple",//待修
    "maintenance.trans": "cyan",//已转接
    "maintenance.stock-io": "magenta",//已出库
    "maintenance.settle": "green",//已结算
    "maintenance.create": "blue",//已开单
    "maintenance.change": "red",//已作废
    "maintenance.completed": "cyan",//已完工,
    "maintenance-status.final": "pink",//已终检,
}

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, reset
    } = useStockOutDispatchModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const onLook = (code: string) => {
        let supplierEditKey = "9-3-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IStockDeliveryDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'maintenanceCode',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onLook(text)} />,
            // render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={(e) => {e.stopPropagation();onLook(text)}}>{text}</p></Tooltip>,
        }, {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: '出库数量',
            width: 80,
            dataIndex: 'deliveryNum',
        }, {
            title: '客户名称',
            width: 120,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '车牌号',
            width: 100,
            dataIndex: 'licensePlate',
        }, {
            title: 'VIN码',
            width: 80,
            dataIndex: 'vin',
        }, {
            title: '领料人',
            width: 100,
            dataIndex: 'technicianNames',
            render: (text: any) => <YhTootip text={text} style={{ width: '100px' }} />,

        }, {
            title: '制单日期',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '出库日期',
            width: 130,
            dataIndex: 'stockIoTime',
            render: (text) => momentFormat(text)
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockDelivery", "roleCodes": roles };
        return getRoleColumns("stockDelivery", "主单", columns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockDeliveryDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}
